import { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import AnalyticsService, { StreamBindFlowEventNameAMP } from 'application/services/AnalyticsService';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { TEXTS } from './texts';
import { useOnboardingContext } from '../../useOnboardingContext';
import { useOnboardingActionContext } from '../../useOnboardingActionContext';
import { FLOWS_FOR_NOT_SHOW_STOP_ONBOARDING_WARNING } from '../../consts';

import styles from './DownloadTVAPPModal.module.scss';
import { SelectPlayerContentViewMode } from '../../types';

const AUDIO_DEVICE_IMAGE_PATH = '/assets/img/app/video/tv_audio.png';
const VIDEO_DEVICE_IMAGE_PATH = '/assets/img/app/video/tv_video.png';

const DownloadTVAppModal: FC<ModalProps[ModalTypes.DOWNLOAD_TV_APP]> = ({ openModal, replaceModal, close }) => {
  const { flowType, contentViewMode } = useOnboardingContext();
  const { clearCurrentPoint } = useOnboardingActionContext();

  const onDownloadClick = () => {
    AnalyticsService.event(StreamBindFlowEventNameAMP.STREAM_MOBILE_DOWNLOAD_CLICKED);
    replaceModal(ModalTypes.VIDEO_PLAYER_BIND, {});
  };

  const handleCancel = () => {
    if (flowType && FLOWS_FOR_NOT_SHOW_STOP_ONBOARDING_WARNING.has(flowType)) {
      close();
      clearCurrentPoint();
      return;
    }

    openModal(ModalTypes.STREAM_STOP_BINDING_FLOW_WARNING, {});
  };

  return (
    <ModalScreen
      titlePlacement="left"
      onClose={handleCancel}
      className={styles.modalContainer}
      contentClassName={styles.modalContent}
      title={TEXTS.MODAL_TITLE}
      containerActionButtonsClassName={styles.actionButtons}
      actionButtons={[
        <Button
          key="button_tv_app_download_modal_success"
          elementId="button_tv_app_download_modal_success"
          type={ButtonType.PRIMARY}
          onClick={onDownloadClick}>
          {TEXTS.SUCCESS_BUTTON}
        </Button>,
        <Button
          key="button_tv_app_download_modal_cancel"
          elementId="button_tv_app_download_modal_cancel"
          type={ButtonType.SECONDARY}
          onClick={() => {
            replaceModal(ModalTypes.CHOOSE_VIDEO_PLAYER, {});
          }}>
          {TEXTS.CANCEL_BUTTON}
        </Button>,
      ]}>
      <div className={styles.downloadContent}>
        <img
          src={
            contentViewMode === SelectPlayerContentViewMode.VIDEO_STREAM
              ? VIDEO_DEVICE_IMAGE_PATH
              : AUDIO_DEVICE_IMAGE_PATH
          }
          alt=""
          loading="lazy"
          className={styles.app}
        />
      </div>

      <div className={styles.text}>
        <div className={styles.textSubtitle}>{TEXTS.SUBTITLE}</div>

        <div className={styles.textDescription}>
          <ol>
            <li>{TEXTS.TURN_ON}</li>
            <li>
              <div>{TEXTS.STORES}</div>
              <ul>
                <li>{TEXTS.GOOGLE_PLAY}</li>
                <li>{TEXTS.PLAY_STORE}</li>
                <li>{TEXTS.APP_GALLERY}</li>
                <li>{TEXTS.APPS}</li>
              </ul>
            </li>
            <li>{TEXTS.CHOOSE}</li>
            <li>{TEXTS.SELECT}</li>
          </ol>
        </div>
      </div>
    </ModalScreen>
  );
};

export default memo(DownloadTVAppModal);
